<template>
    <v-row no-gutters>
        <v-col cols="12" no-gutters>
            <v-container style="height:250px;" >
                <component :click="click()" :content="content_controller.selectedContent"
                    :is="getContentType(content_controller.selectedContent)" />
                <!-- <contentCard :selectedContent="selectedContent" :cycleMethod="nextMethod" /> -->
            </v-container>
        </v-col>
        <v-col no-gutters cols="12">
            <v-toolbar>
                <v-toolbar-title>
                    course
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="content_controller.cycleContent()"> next
                </v-btn>
            </v-toolbar>
            <v-list dense outlined>
                <v-list-item :dark="content_controller.selectedContent==item "
                    :class=" content_controller.selectedContent==item   ? 'highLighted'  :''" @click="setSelected(item)"
                    v-for="(item, idx) in content_controller.list" :key="idx">
                    {{item.description}}
                    <!-- need to change to proper name from data-->
                </v-list-item>
            </v-list>
        </v-col>
    </v-row>
</template>

<script>
    import contentVideo from "../video.vue";
    import contentImage from "../image.vue";
    import contentText from "../content-text.vue";
    import contentTextViewer from "../content-text-viewer";
    export default {
        props: {
            setSelected: Function
        },
        components: {
            contentVideo,
            contentText,
            contentImage,
            contentTextViewer

        },
        data() {
            return {
                content_controller: this.get_controller("content_section"),
                contentTypes: [{
                        text: "contentTextViewer",
                        value: 1
                    },
                    {
                        text: "contentImage",
                        value: 2
                    },
                    {
                        text: "contentVideo",
                        value: 3
                    },
                ],
            }
        },
        methods: {
            click(){},
            getContentType(content) {
                if(content==null)
                return""
                let contentType = this.contentTypes.find(
                    (x) => x.value == content.type
                );
                return contentType.text;
            },
        }
    }
</script>

<style scoped>
    .highLighted {
        background-color: rgb(0, 68, 255);
    }

    .badge {
        position: absolute;
        bottom: 10px;
        right: 10px;
        padding: 5px 10px;
    }
</style>